import { lazy } from 'react';

const passwordRecoveryConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: true,
					style: 'static'
				},
			}
		}
		
	},
	routes: [
		{
			path: '/auth/password-recovery',
			component: lazy(() => import('./passwordRecovery'))
		}
	]
};

export default passwordRecoveryConfig;
